import ExternalLink, { FormatExternalLink } from "./ExternalLink"

type SourceProps = {
    href: string
}

const Source = ({ href }: SourceProps) => {
    const formatted = FormatExternalLink(href)
    const body = <ExternalLink href={href} >{formatted}</ExternalLink>
    return <div className='source'><h3>Read more</h3>{body}</div>
}

export default Source